/*
 * @Author: Hyman Choi
 * @Date: 2021-01-25 09:27:46
 * @LastEditTime: 2022-01-10 11:12:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\videoDetail.js
 */
import request from '@/utils/request'
import config from '@/utils/config'

/**
 * 获取单个视频信息
 *
 * @param {*} params
 */
export function getOne(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminVideos/One',
    method: 'get',
    params
  })
}

/**
 * 更新单个视频信息
 *
 * @param {*} data
 */
export function updateVideo(data) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminVideos/Update',
    method: 'post',
    data
  })
}

/**
 * 获取单个视频评论列表
 *
 * @param {*} params
 */
export function getVideoCommentList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminVideos/VideoCommentList',
    method: 'get',
    params
  })
}

/**
 * 删除/恢复单个视频评论
 *
 * @param {*} params
 */
export function deleteOrBackVideoComment(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminVideos/VideoComment/DeleteOrBack',
    method: 'delete',
    params
  })
}

/**
 * 获取单个视频评论回复列表
 *
 * @param {*} params
 */
export function getReplyVideoCommentList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminVideos/VideoComment/Reply/List',
    method: 'get',
    params
  })
}

/**
 * 获取单个视频点赞用户列表
 *
 * @param {*} params
 */
export function getVideoLikeUserList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminVideos/VideoLikeUserList',
    method: 'get',
    params
  })
}
